import { DE_BIO } from './bio.js';
import { DE_HANDLE_ADJECTIVES, DE_HANDLE_NOUNS, DE_HANDLE_WORDS, DE_PLACE_CODES } from './handles.js';
import { DE_FEMALE, DE_MALE, DE_SURNAMES } from './names.js';
import type { LocalePack } from '../types.js';

/** Letters NFD does not decompose, plus German transliteration (ä→ae, ß→ss). */
const FOLD: Readonly<Record<string, string>> = {
  ä: 'ae', ö: 'oe', ü: 'ue', Ä: 'Ae', Ö: 'Oe', Ü: 'Ue', ß: 'ss', ẞ: 'SS',
  ı: 'i', ł: 'l', Ł: 'L', đ: 'd', Đ: 'D', ø: 'o', Ø: 'O', æ: 'ae', Æ: 'Ae', œ: 'oe', Œ: 'Oe',
};

function asciiFold(s: string): string {
  return s
    .replace(/[äöüÄÖÜßẞıłŁđĐøØæÆœŒ]/g, (c) => FOLD[c] ?? c)
    .normalize('NFD')
    .replace(/\p{M}/gu, '');
}

/** BaseChatFun's German market: Germany, incl. its Turkish-German and migrant-heritage users. */
export const dePack: LocalePack = {
  locale: 'de',
  names: { female: DE_FEMALE, male: DE_MALE, surnames: DE_SURNAMES },
  asciiFold,
  lower: (s) => s.toLocaleLowerCase('de-DE'),
  upper: (s) => s.toLocaleUpperCase('de-DE'),
  handle: {
    words: DE_HANDLE_WORDS,
    adjectives: DE_HANDLE_ADJECTIVES,
    nouns: DE_HANDLE_NOUNS,
    placeCodes: DE_PLACE_CODES,
  },
  bio: DE_BIO,
};
